import React, { useContext, useEffect, useState } from "react";

import {
  Container,
  Grid,
  Paper,
  Avatar,
  Typography,
  Divider,
  Tabs,
  Tab,
  Box,
} from "@material-ui/core";

import { useStyles } from "./styles";
import { getAvataricon } from "../../../utils/getAvatarIcon";
import InterpreterDashboard from "../../../components/Dashboard/InterpreterDashboard/index";
import { DashboardContext } from "../../../context/states/dashboardState";
import { BookingList } from "../../../components/Dashboard/BookingLists";
import { AuthContext } from "../../../context/states/authState";
import FinancialDashboard from "../../../components/Dashboard/FinancialDashboard/index";
import ActivityDashboard from "../../../components/Dashboard/ActivityDashboard/index";

// Create new Date instance
var date = new Date();
date.setDate(date.getDate() + 1);

// Tab Panel
const TabPanel = ({ children, value, index }) => {
  return value === index && <Box mt={2}>{children}</Box>;
};

const Dashboard = () => {
  const classes = useStyles();
  const [tab, setTab] = useState(0);

  const {
    getDashboardsHandler,
    loading,
    data,
    getTodayBookingsHandler,
    todayBookings,
    getTomorrowBookingsHandler,
    tomorrowBookings,
  } = useContext(DashboardContext);

  const { permissionKeys } = useContext(AuthContext);

  useEffect(() => {
    getDashboardsHandler();
    getTodayBookingsHandler();

    const tomorrowDate = new Date(date).toISOString();
    getTomorrowBookingsHandler(tomorrowDate);
  }, []);

  const handleTabChange = (e, newValue) => {
    setTab(newValue);
  };

  // Dynamic Tabs Config
  const tabs = [
    {
      label: "Booking",
      key: "booking",
      permission: "dashboard-booking",
      render: () => (
        <Grid container spacing={1}>
          {data.map((d, i) => (
            <Grid item xs={12} md={2} key={i}>
              <Paper elevation={1} className={classes.paper}>
                <div className={classes.nameDiv}>
                  <Typography variant="h6">{d.name}</Typography>

                  <Typography
                    variant="h4"
                    gutterBottom
                    className={classes.count}
                  >
                    {d.count}
                  </Typography>
                </div>

                <Avatar className={classes[d.cl]}>
                  {getAvataricon(d.icon)}
                </Avatar>
              </Paper>
            </Grid>
          ))}

          <Grid item xs={12}>
            <Divider />
          </Grid>

          <Grid item xs={12}>
            {!loading && (
              <BookingList
                data={todayBookings}
                loading={loading}
                active={classes.currentDayBookings}
                title="Today's Bookings"
              />
            )}
          </Grid>

          <Grid item xs={12}>
            {!loading && (
              <BookingList
                data={tomorrowBookings}
                loading={loading}
                active={classes.upcomingBookings}
                title="Tomorrow's Bookings"
              />
            )}
          </Grid>
        </Grid>
      ),
    },

    {
      label: "Financial",
      key: "dashboard-financial",
      permission: "dashboard-financial",
      render: () => <FinancialDashboard />,
    },

    {
      label: "Interpreter",
      key: "dashboard-interpreter",
      permission: "dashboard-interpreter",
      render: () => <InterpreterDashboard />,
    },

    {
      label: "Activity",
      key: "dashboard-activity",
      permission: "dashboard-activity",
      render: () => <ActivityDashboard />,
    },
  ];

  // Only keep tabs for which the user has permission
  const allowedTabs = tabs.filter((tab) =>
    permissionKeys?.includes(tab.permission),
  );

  // If the currently selected tab is no longer available
  useEffect(() => {
    if (tab >= allowedTabs.length) {
      setTab(0);
    }
  }, [allowedTabs.length, tab]);

  return (
    <Container maxWidth="xl">
      <Tabs value={tab} onChange={handleTabChange}>
        {allowedTabs.map((t) => (
          <Tab key={t.key} label={t.label} />
        ))}
      </Tabs>

      {allowedTabs.map((t, i) => (
        <TabPanel key={t.key} value={tab} index={i}>
          {t.render()}
        </TabPanel>
      ))}
    </Container>
  );
};

export default Dashboard;
